import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {LogLevel} from "../domain/log-level.enum";
import {Logger} from "../domain/logger.interface";
import {RemoteLogger} from "./logger/remote-logger";
import {ConsoleLogger} from "./logger/console-logger";

@Injectable({ providedIn: 'root' })
export class LoggerService {

  private readonly logger: Logger;

  constructor() {
    this.logger = environment.production ? new RemoteLogger() : new ConsoleLogger();
  }

  debug(message: string, context?: unknown) {
    if (environment.asamm.logLevel < LogLevel.DEBUG) {
      return
    }

    this.logger.debug(message, context);
  }

  info(message: string, context?: unknown) {
    if (environment.asamm.logLevel < LogLevel.INFO) {
      return
    }

    this.logger.info(message, context);
  }

  warn(message: string, error?: unknown, context?: unknown) {
    if (environment.asamm.logLevel < LogLevel.WARN) {
        return
    }

    this.logger.warn(message, error, context);
  }

  error(message: string, error?: unknown, context?: unknown) {
    if (environment.asamm.logLevel >= LogLevel.ERROR) {
      return
    }

    this.logger.error(message, error, context);
  }
}
